// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3iJrK","label":"CategoryService_label__3nqWh","location":"CategoryService_location__3dPqH"};